import { Button } from '@design-system/components/button/button';
import { Typography } from '@design-system/components/typography/typography';
import toast from 'react-hot-toast';

export const UndoMove = ({
  itemsCount,
  fromName,
  toName,
  undo,
}: {
  itemsCount: number;
  fromName: string;
  toName: string;
  undo: () => void;
}) =>
  toast((t) => (
    <div className="flex gap-1 items-center">
      <Typography className="w-[250px]">
        Items ({itemsCount}) moved from {fromName} to {toName}
      </Typography>
      <Button
        onClick={() => {
          undo();
          toast.dismiss(t.id);
        }}
        variant="text"
      >
        Undo
      </Button>
    </div>
  ));
